import React, { Component } from 'react';
import ConfirmBox from '../../../../hoc/ConfirmBox';

class SwitchButton extends Component {
    
    state = {
      isConfirmBoxOpen:false
    }

    componentDidMount(){
      // console.log(this.props);
    }

    toggleConfirmBox = (e) => {
      if(e) {
        e.preventDefault();
        e.stopPropagation();
      }
      // Prevent toggle if disabled or if clickHandler is not available
      const {colData} = this.props;
      if(colData.disabled === true || !colData.clickHandler) {
        return;
      }
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen});
    }

    confirmButtonClick = () => {
      const {colData,id,header} = this.props;
      const eventsHandler = {
        onClick:() => (colData.clickHandler) ?
                colData.clickHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      // console.log(eventsHandler);
      eventsHandler.onClick();
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen});
    }

    render () {
      const {colData,id,header} = this.props;
      const eventsHandler = {
        onClick:() => (colData.clickHandler) ?
                colData.clickHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      const access_mode = (colData.access_mode==undefined)? true:colData.access_mode;
      const href = (colData.href) ? colData.href:"#";
      const isDisabled = colData.disabled === true || !colData.clickHandler;
      // console.log(eventsHandler);
        return(
            <td key={"column"+this.props.id}>
              {(access_mode==true)?
                    <div className="material-switch p-2" {...header.attributes} style={isDisabled ? {opacity: 0.6, cursor: 'not-allowed'} : {}}>
                        <input id={"module-Lead"+this.props.id}  {...colData.attributes} checked={colData.checked} type="checkbox" onClick={isDisabled ? undefined : this.toggleConfirmBox} readOnly disabled={isDisabled} />
                        <label htmlFor={"module-Lead"+this.props.id} {...colData.attributes} onClick={(e) => { if (!isDisabled) { e.preventDefault(); this.toggleConfirmBox(e); } }} className="secondary_bg" style={isDisabled ? {cursor: 'not-allowed'} : {cursor: 'pointer'}}></label>
                    </div>                
              :''}

              <ConfirmBox
                isConfirmBoxOpen={this.state.isConfirmBoxOpen}
                toggleConfirmBox={this.toggleConfirmBox}
                confirmButtonClick={this.confirmButtonClick}
                content={colData.content}
              />  
              
            </td>
        );
    }
}

export default SwitchButton;